module.exports = __webpack_public_path__ + "static/Site_Header_Background-652524783c35003c2367a4badf338a9b.png";